module.exports = __webpack_public_path__ + "static/media/yellow_logo.d222a605.png";